import { Injectable, OnDestroy } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';

@Injectable()
export class GlobalDialogService extends DialogService implements OnDestroy {
  private readonly openDialogs: DynamicDialogRef[] = [];
  private readonly instanceId = Math.random().toString(36).substring(7);

  override open(componentType: any, config: any): DynamicDialogRef {
    const ref = super.open(componentType, config) as DynamicDialogRef | null;

    if (!ref) {
      // eslint-disable-next-line no-console
      console.warn(
        `[GlobalDialogService ${this.instanceId}] DialogService.open returned a null/undefined ref`,
      );

      return ref as unknown as DynamicDialogRef;
    }

    this.openDialogs.push(ref);

    ref.onClose.subscribe((_) => {
      const index = this.openDialogs.indexOf(ref);

      if (index > -1) {
        this.openDialogs.splice(index, 1);
      } else {
        // eslint-disable-next-line no-console
        console.warn(
          `[GlobalDialogService ${this.instanceId}] Dialog ref not found in array when onClose fired`,
        );
      }
    });

    return ref;
  }

  closeAll(): void {
    const dialogsToClose = [...this.openDialogs];

    dialogsToClose.forEach((ref) => {
      try {
        ref.close(undefined);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(
          `[GlobalDialogService ${this.instanceId}] Error closing dialog:`,
          error,
        );
      }
    });
    this.openDialogs.length = 0;
  }

  ngOnDestroy(): void {
    this.closeAll();
  }
}
